import { render, staticRenderFns } from "./tat.vue?vue&type=template&id=678af432&"
import script from "./tat.vue?vue&type=script&lang=js&"
export * from "./tat.vue?vue&type=script&lang=js&"
import style0 from "./tat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports